produto.component('produto.produtoComponent', {
    templateUrl: 'produto/produto.html',
    controller: 'produto.produtoController',
    controllerAs: '$ctrl'
});

produto.controller('produto.produtoController', ['$rootScope', '$scope', 'coreLanguage', '$state', 'coreFb', '$filter', function($rootScope, $scope, $text, $state, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    const _getProduto=(idProduto)=>{
        const produtoPath = `cad_produtos/${idProduto}`;

        $fb.db.get(produtoPath).then(doc=>{
            $ctrl.produto = {
                ...doc.data,
                id:doc.id
            };

            return $fb.db.list(`${produtoPath}/sessoes`, [{orderBy:['ordem']}]);

        }).then((sessoes)=>{
            $ctrl.produtoSessoes = $filter('orderBy')(sessoes, 'data.ordem');

            return $fb.db.list(`${produtoPath}/modulos`, [{orderBy:['ordem']}]);

        }).then((modulos)=>{
            $ctrl.modulos = $filter('orderBy')(modulos, 'data.ordem');
            
        }).finally(()=>{
            $state.params.showGlobalLoading = false;
        });

    };

    $ctrl.viewModulo=(modulo)=>{
        if(modulo.data.tipoModulo === 'link'){
            window.open(modulo.data.linkUrl, modulo.data.target);
        }else{
            $state.go('cliente.produtoModulo', {
                idProduto: $ctrl.produto.id,
                idModulo: modulo.id
            });
        }
    };

    $ctrl.$onInit = () => {
        $rootScope.idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        _getProduto($state.params.idProduto);
    };
    
}]);